import React, { useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCrop, setCanvasSize } from '@modules/editor';
import CropCanvas from './CropCanvas';

function CropCanvasContainer() {
    const dispatch = useDispatch();
    const cropList = useSelector((state: any) => state.editor.cropList);
    const vodInfo = useSelector((state: any) => state.media.vodInfo);
    const canvasSize = useSelector((state: any) => state.editor.canvasSize);
    const containerRef = useRef(null);
    const overlayRefs = {
        top: useRef(null),
        left: useRef(null),
        right: useRef(null),
        bottom: useRef(null),
    };

    const syncWithVideo = () => {
        const videoEl = document.querySelector('.vjs-text-track-display');
        if (videoEl && vodInfo) {
            const rect = videoEl.getBoundingClientRect();
            const [width, height] = vodInfo.videoSize.split('x').map(Number);
            const aspectRatio = width / height;
            console.log('videoEl', rect.width, rect.width / aspectRatio);
            dispatch(setCanvasSize({
                canvasWidth: rect.width,
                canvasHeight: rect.width / aspectRatio
            }));
        }
    };

    // 컨테이너 클릭 시 모든 편집 모드 해제
    const handleContainerClick = (e: React.MouseEvent) => {
        const target = e.target as HTMLElement;

        // 크롭 요소를 클릭한 경우가 아니라면 모든 편집 모드 해제
        if (target === e.currentTarget && cropList && cropList.isEditing) {
            dispatch(updateCrop({
                ...cropList,
                isEditing: false
            }));
        }
    };

    useEffect(() => {
        syncWithVideo();
        window.addEventListener('resize', syncWithVideo);
        window.addEventListener('scroll', syncWithVideo);
        return () => {
            window.removeEventListener('resize', syncWithVideo);
            window.removeEventListener('scroll', syncWithVideo);
        };
    }, []);

    const updateOverlays = useCallback(() => {
        const container = containerRef.current;
        if (!container || !cropList || Object.keys(cropList).length === 0) return;

        const containerRect = container.getBoundingClientRect();
        const containerWidth = containerRect.width;
        const containerHeight = containerRect.height;

        // cropList의 x, y, width, height 값을 사용하여 top, left, right, bottom 계산
        const x = parseInt(cropList.x) || 0;
        const y = parseInt(cropList.y) || 0;
        const width = parseInt(cropList.width) || 0;
        const height = parseInt(cropList.height) || 0;

        const top = y;
        const left = x;
        const right = x + width;
        const bottom = y + height;

        if (overlayRefs.top.current) {
            (overlayRefs.top.current as HTMLElement).style.top = '0px';
            (overlayRefs.top.current as HTMLElement).style.left = '0px';
            (overlayRefs.top.current as HTMLElement).style.width = `${containerWidth}px`;
            (overlayRefs.top.current as HTMLElement).style.height = `${top}px`;
        }

        if (overlayRefs.left.current) {
            (overlayRefs.left.current as HTMLElement).style.top = `${top}px`;
            (overlayRefs.left.current as HTMLElement).style.left = '0px';
            (overlayRefs.left.current as HTMLElement).style.width = `${left}px`;
            (overlayRefs.left.current as HTMLElement).style.height = `${height}px`;
        }

        if (overlayRefs.right.current) {
            (overlayRefs.right.current as HTMLElement).style.top = `${top}px`;
            (overlayRefs.right.current as HTMLElement).style.left = `${right}px`;
            (overlayRefs.right.current as HTMLElement).style.width = `${containerWidth - right}px`;
            (overlayRefs.right.current as HTMLElement).style.height = `${height}px`;
        }

        if (overlayRefs.bottom.current) {
            (overlayRefs.bottom.current as HTMLElement).style.top = `${bottom}px`;
            (overlayRefs.bottom.current as HTMLElement).style.left = '0px';
            (overlayRefs.bottom.current as HTMLElement).style.width = `${containerWidth}px`;
            (overlayRefs.bottom.current as HTMLElement).style.height = `${containerHeight - bottom}px`;
        }
    }, [cropList]);

    useEffect(() => {
        window.addEventListener('resize', updateOverlays);
        updateOverlays(); // 초기 실행

        return () => {
            window.removeEventListener('resize', updateOverlays);
        };
    }, [updateOverlays]);

    return (
        <div
            className="container-cropCanvas"
            style={{
                width: `${canvasSize.canvasWidth}px`,
                height: `${canvasSize.canvasHeight}px`,
                position: 'absolute',
                zIndex: 997
            }}
            ref={containerRef}
            onClick={handleContainerClick}
        >
            <div ref={overlayRefs.top} className="overlay top" />
            <div ref={overlayRefs.left} className="overlay left" />
            <div ref={overlayRefs.right} className="overlay right" />
            <div ref={overlayRefs.bottom} className="overlay bottom" />

            {cropList && Object.keys(cropList).length > 0 && (
                <CropCanvas />
            )}
        </div>
    );
}

export default CropCanvasContainer; 